import axios from 'axios';

const User = {
    namespaced: true,    
    actions: {
       DeleteUndeleteUser({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}User/DeleteUndeleteUser`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},          
    },
}

export default User